import {integerFormatter, dateFormatter, shortDateFormatter} from "../../gridFormatters";

export const switchesSummary = [
	{
		"field": "switch_name",
		"headerName": "Switch Name",
	},
	{
		"field": "group_name",
		"headerName": "Group Name",
	},
	{
		"field": "data_center",
		"headerName": "Data Center",
		"hide": true
	},
	{
		"field": "fabric",
		"headerName": "Fabric",
		"hide": true
	},
	{
		"field": "function",
		"headerName": "Function",
		"hide": true
	},
	{
		"field": "total_ports",
		"headerName": "Total Ports",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "licensed_port_count",
		"headerName": "Licensed Ports",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "unlicensed_ports",
		"headerName": "Unlicensed Ports",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "used_ports",
		"headerName": "Used Ports",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "free_ports",
		"headerName": "Free Ports",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "unused_licensed_ports",
		"headerName": "Unused Licensed Ports",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "port_error_count",
		"headerName": "Total Errors On All Ports",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "ports_who_own_error_record",
		"headerName": "Total Ports With Errors",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "collection_date",
		"headerName": "Collection Date",
		"filter": "agDateColumnFilter",
		"cellRenderer": dateFormatter
	},
	{
		"field": "os_version",
		"headerName": "Firmware Version"
	},
	{
        "field": "end_of_service_life",
        "headerName": "End of Service Life",
        "filter": "agDateColumnFilter",
        "cellRenderer": shortDateFormatter,
    },
	{
		"field": "device_type_code",
		"headerName": "Device Type"
	},
	{
		"field": "device_type_description",
		"headerName": "Device Type Description"
	},
	{
		"field": "fc_used_licensed",
		"headerName": "FC Used Licensed",
        "type": "numericColumn",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "fc_free_licensed",
		"headerName": "FC Free Licensed",
        "type": "numericColumn",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "icl_used_licensed",
		"headerName": "ICL Used Licensed",
        "type": "numericColumn",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "icl_free_unlicensed",
		"headerName": "ICL Free Unlicensed",
        "type": "numericColumn",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	}
];

export const switchesErrorTrend = [
	{
		"field": "collection_date",
		"headerName": "Collection Date",
		"filter": "agDateColumnFilter",
		"cellRenderer": dateFormatter
	},
	{
		"field": "switch_name",
		"headerName": "Switch Name",
	},
	{
		"field": "bb_credit_zero_rx_warning",
		"headerName": "BB Credit Zero RX Warning",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "bb_credit_zero_tx_warning",
		"headerName": "BB Credit Zero TX Warning",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "class_3_discard",
		"headerName": "Class 3 Discard",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "crc_errors",
		"headerName": "CRC Errors",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "frame_too_long_short",
		"headerName": "Frame Too Long or Short",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "link_failure",
		"headerName": "Link Failure",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "link_reset",
		"headerName": "Link Reset",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "loss_of_sync_signal",
		"headerName": "Loss of Sync Signal",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "port_latency",
		"headerName": "Port Latency",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "slow_drain_device",
		"headerName": "Slow Drain Device",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum"
	}
];
export const sanPortDetail = [
	{'field': "host_port_internal_name", 'headerName': "Host Port Internal Name", 'enableRowGroup': 'True',
		'cellRenderer': 'blankForNullFormatter'},
	{'field': "host_port_alias", 'headerName': "Host Port Alias", 'enableRowGroup': 'True',
		'cellRenderer': 'blankForNullFormatter'},

	{'field': "host_port_current_speed", 'headerName': "Host Port Current Speed", 'enableRowGroup': 'True',
		'cellRenderer': 'integerFormatter', 'cellStyle': {'text-align': 'center'}},
	{'field': "host_port_max_speed", 'headerName': "Host Port Max Speed", 'enableRowGroup': 'True',
		'cellRenderer': 'integerFormatter', 'cellStyle': {'text-align': 'center'}},
	{'field': "host_port_errors", 'headerName': "Host Port Errors", 'enableRowGroup': 'True',
		'cellRenderer': 'integerFormatter', 'cellStyle': {'text-align': 'center'}},
	{'field': "host_switch_name", 'headerName': "Host Switch Name", 'enableRowGroup': 'True'},
	{'field': "host_name", 'headerName': "Host Name", 'enableRowGroup': 'True'},
	{'field': "host_wwn", 'headerName': "Host wwn", 'enableRowGroup': 'False'},
	{'field': "storage_port_internal_name", 'headerName': "Storage Port Internal Name",
		'enableRowGroup': 'True',
		'cellRenderer': 'blankForNullFormatter'},
	{'field': "storage_port_alias", 'headerName': "Storage Port Alias", 'enableRowGroup': 'True',
		'cellRenderer': 'blankForNullFormatter'},

	{'field': "storage_port_current_speed", 'headerName': "Storage Port Current Speed",
		'enableRowGroup': 'True',
		'cellRenderer': 'integerFormatter', 'cellStyle': {'text-align': 'center'}},
	{'field': "storage_port_max_speed", 'headerName': "Storage Port Max Speed", 'enableRowGroup': 'True',
		'cellRenderer': 'integerFormatter', 'cellStyle': {'text-align': 'center'}},

	{'field': "storage_port_errors", 'headerName': "Storage Port Errors",
		'filter': "agNumberColumnFilter", 'filterParams': {'cellHeight': 20, 'debounceMs': 1000},
		'cellRenderer': 'integerFormatter', 'cellStyle': {'text-align': 'center'}, 'enableRowGroup': 'True'},
	{'field': "storage_switch_name", 'headerName': "Array Switch", 'enableRowGroup': 'True'},
	{'field': "device_name", 'headerName': "Array", 'enableRowGroup': 'True'},
	{'field': "storage_type", 'headerName': "Array Type", 'enableRowGroup': 'True'},

	{'field': "device_wwn", 'headerName': "Array wwn", 'enableRowGroup': 'False'},
	{'field': "zone_name", 'headerName': "Zone Name", 'enableRowGroup': 'True'}
]
export const switchesZoneDetail = [
    {
        "field": "zone_name",
        "headerName": "Zone Name",
        "enableRowGroup": true
    },
    {
        "field": "host_name",
        "headerName": "Host Name",
        "enableRowGroup": true
    },
    {
        "field": "host_switch_name",
        "headerName": "Host Switch Name",
        "enableRowGroup": true
    },
    {
        "field": "host_wwn",
        "headerName": "Host wwn",
        "enableRowGroup": false
    },
    {
        "field": "host_port_internal_name",
        "headerName": "Host Port Internal Name",
        "enableRowGroup": true,
        "cellRenderer": "blankForNullFormatter"
    },
    {
        "field": "host_port_alias",
        "headerName": "Host Port Alias",
        "enableRowGroup": true,
        "cellRenderer": "blankForNullFormatter"
    },
    {
        "field": "host_port_errors",
        "headerName": "Host Port Errors",
        "enableRowGroup": true,
        "cellRenderer": integerFormatter,
        "cellStyle": {
            "text-align": "center"
        }
    },
    {
        "field": "device_name",
        "headerName": "Device",
        "enableRowGroup": true
    },
    {
        "field": "storage_switch_name",
        "headerName": "Device Switch",
        "enableRowGroup": true
    },
    {
        "field": "storage_type",
        "headerName": "Device Type",
        "enableRowGroup": true
    },
    {
        "field": "storage_port_internal_name",
        "headerName": "Storage Port Internal Name",
        "enableRowGroup": true,
        "cellRenderer": "blankForNullFormatter"
    },
    {
        "field": "storage_port_alias",
        "headerName": "Storage Port Alias",
        "enableRowGroup": true,
        "cellRenderer": "blankForNullFormatter"
    },
    {
        "field": "storage_array_port_errors",
        "headerName": "Storage Port Errors",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": integerFormatter,
        "cellStyle": {
            "text-align": "center"
        },
        "enableRowGroup": true
    },
    {
        "field": "device_wwn",
        "headerName": "Device wwn",
        "enableRowGroup": false
    }
]